import { useQuery } from '@tanstack/react-query';

import { apiCall, apiClient } from 'shared/client/apiClient';

export const pblSnapshotByIdQueryKey = (pblSnapshotId?: string) => ['pbl-snapshot', { pblSnapshotId }] as const;

export const getPBLSnapshotById = async ({ pblSnapshotId }: { pblSnapshotId?: string }) => {
  if (!pblSnapshotId) {
    throw new Error('No `pblSnapshotId`');
  }

  const data = await apiCall(
    apiClient.GET('/pbl-snapshots/{pblSnapshotId}', {
      params: { path: { pblSnapshotId } }
    })
  );

  return data as any; //FIXME provide return type
};

export const useGetPBLSnapshotByIdQuery = (pblSnapshotId?: string) => {
  return useQuery({
    queryKey: pblSnapshotByIdQueryKey(pblSnapshotId),
    queryFn: () => getPBLSnapshotById({ pblSnapshotId }),
    enabled: !!pblSnapshotId
  });
};
